module.exports = __webpack_public_path__ + "static/img/gift9.6ffb7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/shuang12/gift9.png
// module id = b5W4
// module chunks = 86